
import { get, post } from '@Lib/request'
import { path } from './url'

const { usedCarApiV4 } = path

export function fetchAdItems() {
  return get(`${usedCarApiV4}/ad/member/selectItem`)
}

export function fetchItemInfo(params: { itemId: string }) {
  return get(`${usedCarApiV4}/ad/member/itemInfo`, params)
}

export function fetchAdInfo(params: { id: string }) {
  return get(`${usedCarApiV4}/ad/member/adInfo`, params)
}

export function fetchAdSlots(params: { itemId: number }) {
  return get(`${usedCarApiV4}/ad/member/adSlot`, params)
}

export function saveAd(data: any) {
  return post(`${usedCarApiV4}/ad/member/saveAd`, data)
}

export function fetchPayInfo(params: { id: number, isRenew?: number }) {
  return get(`${usedCarApiV4}/ad/member/adPayInfo`, params)
}

export function checkPay(params: { id: number }) {
  return get(`${usedCarApiV4}/ad/member/adPayBeforeCheck`, params)
}

export function payItemAd(data: { id: number, couponId?: number, isRenew?: number }) {
  return post(`${usedCarApiV4}/ad/member/adPay`, data)
}

export function fetchAdList(params: {
  tab: 'prep' | 'show' | 'unshow' | 'notPass'
  brandId?: string
  kindId?: string
  itemId?: string
  page?: string
  pageSize?: string
}) {
  return get(`${usedCarApiV4}/ad/member/adList`, params)
}

export function fetchAdBrand(params: {
  tab: 'prep' | 'show' | 'unshow' | 'notPass'
}) {
  return get(`${usedCarApiV4}/ad/member/brandKind`, params)
}

export function deleteAd(id: number) {
  return post(`${usedCarApiV4}/ad/member/delete`, { id })
}

export function fetchAdsEffect() {
  return get<any>(`${usedCarApiV4}/ad/member/adsEffect`)
}

export function fetchAdEffect() {
  return get(`${usedCarApiV4}/ad/member/adsItemEffect`)
}

export function invalidAd(id: number) {
  return post(`${usedCarApiV4}/ad/member/unshow`, { id })
}

export function fetchRemind() {
  return get<any>(`${usedCarApiV4}/effectAd/member/remind`)
}

export function fetchItemListRemind() {
  return get<any>(`${usedCarApiV4}/effectAd/member/itemlist/remind`)
}